import { createFileRoute } from "@tanstack/react-router";
import { routeHead } from "@/components/seo";
import { breadcrumbSchema } from "@/lib/schema";
import { industries } from "@/content";
import { industryDetails } from "@/content/details";
import { DetailPage } from "@/components/detail-page";

const ROUTE = "/industries/service-businesses";
export const Route = createFileRoute("/industries/service-businesses")({
  head: () =>
    routeHead(ROUTE, {
      title: "Outsourced Finance for Service Businesses | NextEra",
      description:
        "A coordinated outsourced finance function for established Australian service businesses.",
      jsonLd: breadcrumbSchema([
        { name: "Home", item: "/" },
        { name: "Industries", item: "/industries" },
        { name: "Service Businesses", item: ROUTE },
      ]),
    }),
  component: Page,
});
function Page() {
  const i = industries.find((x) => x.href === ROUTE)!;
  return (
    <DetailPage
      eyebrow="Industry"
      heading={i.name}
      description={i.summary}
      content={industryDetails[ROUTE]}
      related={industries
        .filter((x) => x.href !== ROUTE)
        .map((x) => ({ label: x.name, href: x.href }))}
    />
  );
}
